import { memo } from 'react'

import HeaderOverhaul from '@/components/elements/headerOverhaul'
import TextSection from '@/components/elements/texts/textSection'

const LegalDocument = ({ data }) => {
  const { header, sections } = data

  return (
    <div className="legal-container">
      {header && <HeaderOverhaul header={header} darkBackground />}
      <div className="legal-text-container">
        {sections.map(section => (
          <TextSection data={section} key={section.title} className="legal-text" />
        ))}
      </div>
    </div>
  )
}

export default memo(LegalDocument)
